export const BUDGET_SPENT_THRESHOLD_80 = 80;
export const BUDGET_SPENT_THRESHOLD_100 = 100;
